import React, { useEffect, useState } from "react";
import { Button, ButtonToolbar, Loader, Container, Modal } from "rsuite";
import { ProductServices } from "../../../core/services/ProductServices";
import { UtilityServices } from "../../../core/services/UtilityServices";
import "./Customer.css";
import { useTranslation } from "react-i18next";
import { get } from "lodash/fp";
import Customer from "./Customer";
import { Permission } from "./CustomerDataTypes";

const AddCustomerModal = ({
  companyId,
  storeId,
  openModal,
  setOpenModal,
  onAddCustomer,
  defaultValues = { customer_source_id: "" },
  ...props
}: {
  companyId?: number;
  storeId?: number;
  openModal: boolean;
  setOpenModal: Function;
  onAddCustomer?: Function;
  defaultValues?: any;
}) => {
  const { t } = useTranslation();

  const [loader, setLoader] = useState(false);
  const [productInfo, setProductInfo] = useState<any>({});
  const [productTypeFieldDetails, setProductTypeFieldDetails] = useState<any>(
    []
  );

  return (
    <div className="modal-container">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Modal
        open={openModal}
        backdrop={false}
        onClose={(e: any) => {
          setOpenModal("");
        }}
        size="lg"
      >
        <Modal.Header>
          <h4 className="text-center">
            {t("ADD")} {t("CUSTOMER")}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="add-customer">
            <Customer
              withHeader={false}
              withCancelButton={false}
              withCredentials={false}
              onAdd={onAddCustomer}
              defaultValues={defaultValues}
            />
            <ButtonToolbar className="btn-center">
              <Button
                onClick={(e: any) => setOpenModal("")}
                color="red"
                appearance="primary"
              >
                {t("CLOSE")}
              </Button>
            </ButtonToolbar>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AddCustomerModal;
